export interface RefinementMenu {
  attribute: string;
  component: 'CollapsibleRefinementList';
  conditional?: boolean;
  header: string;
  operator: 'and' | 'or';
}

export const plpRefinementMenus: RefinementMenu[] = [
  {
    attribute: 'Product.facets.value',
    component: 'CollapsibleRefinementList',
    header: 'diets & ingredients',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.category',
    component: 'CollapsibleRefinementList',
    header: 'category',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.product type',
    component: 'CollapsibleRefinementList',
    header: 'type',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.size',
    component: 'CollapsibleRefinementList',
    header: 'size',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.roast',
    component: 'CollapsibleRefinementList',
    header: 'roast',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.salt',
    component: 'CollapsibleRefinementList',
    header: 'salt',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.chocolate',
    component: 'CollapsibleRefinementList',
    header: 'chocolate type',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.flavor',
    component: 'CollapsibleRefinementList',
    header: 'flavor',
    operator: 'and',
  },
  {
    attribute: 'Product.facets.color',
    component: 'CollapsibleRefinementList',
    header: 'color',
    operator: 'and',
  },
];

export const searchRefinementMenus = [...plpRefinementMenus];
